import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { Params, RouterModule } from '@angular/router';

import { LinkTarget } from '../../core';
import { IsExternalPipe } from '../../pipes/link-parser/is-external.pipe';
import { LinkParsePipe } from '../../pipes/link-parser/link-parser.pipe';

@Component({
	selector: 'valk-core-smart-link',
	standalone: true,
	imports: [RouterModule, IsExternalPipe, LinkParsePipe, CommonModule],
	changeDetection: ChangeDetectionStrategy.OnPush,
	template: `
		<ng-template #contentTpl><ng-content /></ng-template>

		@let href = url();

		@if (!(href | isExternal)) {
			<a
				[attr.data-test-id]="testId()"
				[ngClass]="className()"
				[queryParams]="queryParams()"
				[routerLink]="[href | linkparse]"
				[target]="target()"
			>
				<ng-container [ngTemplateOutlet]="contentTpl" />
			</a>
		} @else {
			<a
				[attr.data-test-id]="testId()"
				[href]="href"
				[ngClass]="className()"
				[rel]="rel() ?? 'noopener noreferrer'"
				[target]="target()"
			>
				<ng-container [ngTemplateOutlet]="contentTpl" />
			</a>
		}
	`,
})
export class SmartLinkComponent {
	readonly url = input.required<string>();
	readonly queryParams = input<Params>();
	readonly className = input<string | undefined>(undefined);
	readonly testId = input<string | undefined>(undefined);

	readonly target = input<LinkTarget | undefined>(undefined);
	readonly rel = input<string | undefined>(undefined);
}
